module.exports = __webpack_public_path__ + "static/media/hana.da9e57de.png";